import { DevicesContext } from '../context/DeviceContext'
import { useContext } from 'react'

export const useDevicesContext = () => {
  const context = useContext(DevicesContext)

  if (!context) {
    throw Error('useDevicesContext must be used inside an DevicesContextProvider')
  }

  return context
}